<template>
	<div>
		<el-form :inline="true" class="form">
			<el-form-item :label='$t("statistics.speedQuery")' style="margin-right:20px" v-if="speedShow"
				class="input-number">
				<el-input-number v-model="form.speed" controls-position="right" :size="size" :min="0"
					style="width:100px;padding-left:0px"></el-input-number>
			</el-form-item>
			<el-form-item :label='$t("time.timeQuery")'>
				<el-select v-model="searchType" style="width:140px" :size="size" class="selectIcon"
					@change='changeSelect'>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="searchShow">
				<el-date-picker :size="size" style="width:302px;" v-model="searchTime" type='daterange'
					:picker-options="datePickerOptions" :range-separator='$t("time.to")'
					:start-placeholder='$t("time.startDate")' :end-placeholder='$t("time.endDate")'>
				</el-date-picker>
			</el-form-item>
			<el-form-item v-if="searchShow">
				<el-button type="primary"  :size="size" style="margin-left:8px;"
					@click="handleQuery">{{ $t("public.query")}}</el-button>
			</el-form-item>
			<el-form-item v-else>
				<el-button v-for="item in btns" :key="item.value" :type="showBtn == item.value ? 'primary' :''"
					:size="size" style="margin-left:8px;text-align:center;"
					@click="quickQuery(item.value)">{{item.label}}</el-button>
			</el-form-item>
			<el-form-item v-if="addstate">
				<el-button :size="size" type="success" style="margin-left:10px"
					@click="newadd">{{ $t("public.add")}}</el-button>
			</el-form-item>
			<el-form-item>
				<el-button :size="size" plain type="primary" style="margin-left:10px"
					@click="download">{{ $t("public.export")}}</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				datePickerOptions: {
					disabledDate(date) {
						return date > new Date(new Date().getTime())
					}
				},
				showBtn: undefined, //按钮默认选中：今天
				btns: [],
				searchTime: [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date(new Date().getTime())], //
				options: [],
				form: {
					speed: 0,
					beginDate: "",
					endDate: "",
					pageNum: 1,
					pageSize: 10,
				},
				searchType: this.newsearchType,
			}
		},
		// props:["speedShow","isNow"],
		props: {
			speedShow: {
				type: Boolean,
				default: false
			},
			isNow: {
				type: Boolean,
				default: false
			},
			addstate: {
				type: Boolean,
				default: false
			},
			newsearchType: 0
		},
		computed: {
			searchShow() {
				return this.searchType == 0 ? true : false;
			},
			size() {
				return this.$store.getters.size
			}
		},
		mounted() {
			this.btns = [{
					value: 0,
					label: this.$t("time.lastMonth")
				},
				{
					value: 1,
					label: this.$t("time.thisMonth")
				},
				{
					value: 2,
					label: this.$t("time.lastWeek")
				},
				{
					value: 3,
					label: this.$t("time.thisWeek")
				},
				{
					value: 4,
					label: this.$t("time.beforyesterday")
				},
				{
					value: 5,
					label: this.$t("time.yesterday")
				},
				{
					value: 6,
					label: this.$t("time.today")
				},
			];
			if (this.isNow) {
				this.btns.push({
					value: 6,
					label: this.$t("time.today")
				}, )
			}
			this.options = [{
					value: 0,
					label: this.$t("time.generalQuery")
				},
				{
					value: 1,
					label: this.$t("time.quickQuery"),
				}
			];
			this.$nextTick(() => {
				this.handleQuery();
			});
		},
		methods: {
			handleQuery(e) {
				// console.log(this.searchTime[0],"查询时间");
				this.form.beginDate =
					this.searchTime != null && this.searchTime[0] != undefined ?
					this.format(this.searchTime[0], "yyyy-MM-dd") :
					"";
				this.form.endDate =
					this.searchTime != null && this.searchTime[1] != undefined ?
					this.format(this.searchTime[1], "yyyy-MM-dd") :
					"";

				// console.log(this.form.beginDate,this.form.endDate);
				this.$emit("handleQuery", this.form);

			},
			download() {
				this.$emit("download");
			},
			newadd() {
				this.$emit("newadd");
			},
			quickQuery(val) {
				this.showBtn = val;
				let getDay = new Date().getDay();
				let getNowMonth = new Date().getMonth() + 1 + "";
				getNowMonth = getNowMonth.length == 2 ? getNowMonth : ("00" + getNowMonth).substring(("" + getNowMonth)
					.length);
				let day = 24 * 60 * 60 * 1000;
				this.showBtn = val;
				switch (this.showBtn) {
					case 0:
						let getLastMonth = new Date().getMonth() + "";
						getLastMonth = getLastMonth.length == 2 ? getLastMonth : ("00" + getLastMonth).substring(("" +
							getLastMonth).length);
						//跨年特殊处理
						if (getLastMonth == "00") {
							let today = new Date();
							this.form.beginDate = this.format(new Date(), today.getFullYear() - 1 + "-12-01", )
							this.form.endDate = this.format(new Date(), today.getFullYear() - 1 + "-12-31", )
						} else {
							this.form.beginDate = this.format(new Date(), "yyyy-" + getLastMonth + "-01");
							this.form.endDate = this.format(new Date(), "yyyy-" + getLastMonth + "-" + this.getCountDays(
								this.form.beginDate));
						}
						break;
					case 1: //本月
						this.form.beginDate = this.format(new Date(), "yyyy-" + getNowMonth + "-01");
						this.form.endDate = this.format(new Date(new Date().getTime()), "yyyy-MM-dd");
						// console.log(this.form);
						break;
					case 2:
						this.form.beginDate = this.format(new Date(new Date().getTime() - (getDay + 6) * day),
							"yyyy-MM-dd");
						this.form.endDate = this.format(new Date(new Date().getTime() - getDay * day), "yyyy-MM-dd");
						// console.log(this.form);
						break;
					case 3:
						this.form.beginDate = this.format(new Date(new Date().getTime() - (getDay - 1) * day),
							"yyyy-MM-dd");
						this.form.endDate = this.format(new Date(new Date().getTime() - day), "yyyy-MM-dd");
						// console.log(this.form);
						break;
					case 4: //前天
						this.form.beginDate = this.format(new Date(new Date().getTime() - 2 * day), "yyyy-MM-dd");
						this.form.endDate = this.form.beginDate;
						// console.log(this.form);
						break;
					case 5:
						this.form.beginDate = this.format(new Date(new Date().getTime() - day), "yyyy-MM-dd");
						this.form.endDate = this.form.beginDate;
						// console.log(this.form);
						break;
					case 6:
						this.form.beginDate = this.format(new Date(), "yyyy-MM-dd");
						this.form.endDate = this.form.beginDate;
						// console.log(this.form);
						break;
				}
				// console.log(this.form.beginDate,this.form.endDate);
				this.$emit("quickQuery", this.form, this.showBtn);
			},
			format(datetime, format) {
				var o = {
					"M+": datetime.getMonth() + 1, //month
					"d+": datetime.getDate(), //day
					"h+": datetime.getHours(), //hour
					"m+": datetime.getMinutes(), //minute
					"s+": datetime.getSeconds(), //second
					"q+": Math.floor((datetime.getMonth() + 3) / 3), //quarter
					S: datetime.getMilliseconds(), //millisecond
				};

				if (/(y+)/.test(format)) {
					format = format.replace(
						/(y+)/.exec(format)[0],
						(datetime.getFullYear() + "").substring(4 - /(y+)/.exec(format)[0].length)
					);
				}

				for (var k in o) {
					// console.log(o[k]);
					if (new RegExp("(" + k + ")").test(format)) {
						let item = eval("/(" + k + ")/.exec(format)[0]")
						format = format.replace(
							item,
							item.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length)
						);
						// console.log(format,"0.0");
					}
				}
				return format;
			},
			// 获取一个月有多少天，curDate是开始日期，获取这个日期的月份的天数
			getCountDays(curDate) {
				const d = new Date(curDate)
				const y = d.getFullYear()
				//获取本月的下一个月
				const m = d.getMonth() + 1
				// 下一个月的第0天就是这个月的天数
				const days = new Date(y, m, 0).getDate()
				return days
			},
			changeSelect(val) {
				this.$emit('childEvent', val);
			}
		},
	}
</script>

<style lang="scss" scoped>
	.input-number   {
		::v-deep	.el-input {
			position: relative;

			&::before {
				// 也可以将此处的分钟换成其他单位
				content: "km/h";
				position: absolute;
				top: 0;
				right: 25px;
				height: 32px;
				line-height: 35px;
				color: #0F1A3A;
				font-size: 12px;
			}
		}

		// .el-input__inner {
		//   padding-right: 64px;
		// }

		::v-deep	.el-input-number {

			&__increase,
			&__decrease {
				background-color: transparent;
				border: 0 !important;
				width: 25px;
			}

			.el-icon-arrow-up::before {
				content: "";
			}

			.el-icon-arrow-down::before {
				content: "";
			}

			&.is-controls-right .el-input-number__decrease [class*=el-icon],
			&.is-controls-right .el-input-number__increase [class*=el-icon] {
				transform: scale(1.1);
			}
		}

		::v-deep	.el-input-number.is-controls-right .el-input__inner {
			padding-left: 5px;
		}
	}

	 
	.form   {
		::v-deep .el-form-item {
			margin-bottom: 0px !important;
		}

		::v-deep	.el-form-item__label {
			font-size: 12px;
		}

	}
</style>